import { useTranslation } from "react-i18next"
import { Typography } from "@mui/material"
import { DateTime } from "luxon"

import RelativeTime from "widgets/dates/RelativeTime"

interface LastUpdatedProps {
  at?: number
  mt?: number
}

const LastUpdated = ({ at, mt = 1 }: LastUpdatedProps) => {
  const { t } = useTranslation()

  if (at === undefined) {
    return null
  }
  return (
    <Typography variant="caption" color="neutral.600" component="p" mt={mt}>
      {t("alerts_summary.UPDATED")} <RelativeTime date={DateTime.fromMillis(at)} />
    </Typography>
  )
}

export default LastUpdated
